export const TRANSACTION_SERVICES_QUERY_KEY = 'transactionServices'
export const TRANSACTIONS_QUERY_KEY = 'transactions'
export const TRANSACTIONS_SALARIES_QUERY_KEY = 'transactionsSalaries'
export const TRANSACTIONS_WITH_BOOKING_LOCATION_QUERY_KEY = 'transactionsWithBookingLocations'
export const TRANSACTIONS_BRIEF_WITH_CARDS_QUERY_KEY = 'transactionsBriefWithCards'
export const TRANSACTIONS_BRIEF_WITH_MOVEMENTS_QUERY_KEY = 'transactionsBriefWithMovements'
export const TRANSACTIONS_BRIEF_WITH_CLIENT_QUERY_KEY = 'transactionsBriefWithClient'
export const TRANSACTIONS_BRIEF = 'transactionsBrief'
export const TURNOVER_QUERY_KEY = 'turnover'
